module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "editor",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', [_c('router-link', {
    staticClass: "alt-font",
    attrs: {
      "to": _vm.galleryLink
    }
  }, [_vm._v("‹ Pattern Gallery")])], 1), _vm._v(" "), _c('design-view', {
    attrs: {
      "design": _vm.design
    },
    on: {
      "block-click": _vm.onBlockClick,
      "block-drop": _vm.onBlockDrop,
      "block-drag": _vm.onBlockDrag
    }
  }), _vm._v(" "), (_vm.showHelpNote) ? _c('div', {
    staticClass: "help-note"
  }, [_vm._v(_vm._s(_vm.helpNote))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "download-pdf"
  }, [_c('download-pdf')], 1), _vm._v(" "), _c('div', {
    staticClass: "save-or-share"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Save or Share Design")]), _vm._v(" "), _c('save-form')], 1)], 1), _vm._v(" "), (_vm.brand === 'filzfelt') ? _c('div', {
    staticClass: "colors"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "colors-container"
  }, _vm._l((Object.entries(_vm.colors)), function(ref) {
    var key = ref[0];
    var c = ref[1];

    return _c('div', {
      staticClass: "color-circle-container"
    }, [_c('button', {
      staticClass: "color-circle",
      class: _vm.activeColor === key && 'active',
      style: (("background: " + (c.value))),
      on: {
        "click": function($event) {
          _vm.setActiveColor(key)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip alt-font"
    }, [_c('span', {
      staticClass: "tooltip-content"
    }, [_vm._v(_vm._s(c.idx) + " " + _vm._s(c.name))])])])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.isSp402 && _vm.brand === 'spinneybeck') ? _c('div', {
    staticClass: "customize"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Customize")]), _vm._v(" "), _vm._l((_vm.customBlocks), function(cb) {
    return _c('div', {
      staticClass: "customize-button"
    }, [_c('button', {
      directives: [{
        name: "draggable",
        rawName: "v-draggable"
      }],
      class: _vm.activeCustomBlock === cb.id && 'active',
      attrs: {
        "data-drag": _vm.getCustomBlockData(cb)
      },
      on: {
        "click": function($event) {
          _vm.setActiveCustomBlock(cb)
        },
        "drag-start": function($event) {
          _vm.grabCustomBlock(cb)
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 16 16"
      }
    }, [_c('path', {
      attrs: {
        "d": cb.d
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "tooltip alt-font"
    }, [_c('span', {
      staticClass: "tooltip-content"
    }, [_vm._v(_vm._s(cb.name))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "customize-button"
  }, [_c('button', {
    staticClass: "rotate-button",
    class: _vm.activeRotate && 'active',
    on: {
      "click": function($event) {
        _vm.setActiveRotate()
      }
    }
  }), _vm._v(" "), _vm._m(0)])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "label-switch"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Width")]), _vm._v(" "), (_vm.showMetric) ? [_c('button', {
    staticClass: "unit-switch",
    on: {
      "click": _vm.switchUnits
    }
  }, [_vm._v("Switch to " + _vm._s(_vm.metric ? 'Imperial' : 'Metric'))])] : _vm._e()], 2), _vm._v(" "), _c('dimension-input', {
    attrs: {
      "id": ((this._uid) + "-input-width"),
      "value": _vm.design.width,
      "showInches": _vm.showInches
    },
    on: {
      "input": _vm.setWidth
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Height")]), _vm._v(" "), _c('dimension-input', {
    attrs: {
      "value": _vm.design.height,
      "showInches": _vm.showInches
    },
    on: {
      "input": _vm.setHeight
    }
  }), _vm._v(" "), (_vm.showPatternRepeatHeight) ? [_c('p', {
    staticClass: "min-height-message"
  }, [_vm._v("Pattern has a repeat of " + _vm._s(_vm.patternRepeatHeight) + ".")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Pattern")]), _vm._v(" "), _c('select', {
    staticClass: "select",
    domProps: {
      "value": _vm.design.pattern
    },
    on: {
      "change": function($event) {
        _vm.setPattern($event.target.value)
      }
    }
  }, _vm._l((_vm.patterns), function(p) {
    return _c('option', {
      domProps: {
        "value": p.id
      }
    }, [_vm._v(_vm._s(p.name))])
  }))]), _vm._v(" "), (_vm.brand === 'filzfelt') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.clearColorForAll()
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), (_vm.showFill) ? [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeColor && _vm.setColorForAll(_vm.activeColor)
      }
    }
  }, [_vm._v("Fill")])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('router-link', {
    staticClass: "alt-font",
    attrs: {
      "to": "view"
    }
  }, [_vm._v("View Specs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "need-help-container"
  }, [_c('a', {
    staticClass: "alt-font",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Need Help?")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip how-to"
  }, [_c('div', {
    staticClass: "tooltip-content alt-font"
  }, [_c('ol', _vm._l((_vm.howToText), function(step) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(step)
      }
    })
  }))])])])])])]), _vm._v(" "), (_vm.ghostBlock) ? _c('div', {
    staticClass: "ghost-block",
    style: (("top: " + (_vm.cursorY - 25) + "px; left: " + (_vm.cursorX - 25) + "px"))
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.ghostBlock.d,
      "transform": ("rotate(" + (_vm.ghostBlock.r || 0) + " 8 8)")
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tooltip alt-font"
  }, [_c('span', {
    staticClass: "tooltip-content"
  }, [_vm._v("Rotate")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply-color-container"
  }, [_c('label', {
    staticClass: "alt-font"
  }, [_vm._v("Apply Color")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip apply-color alt-font"
  }, [_c('span', {
    staticClass: "tooltip-content"
  }, [_vm._v("Select ‘Single’ to add color to individual tiles or ‘All’ to add one color\n              to entire wall. To switch color of a tile, selection ‘Single’, click on another color, and then click on\n              that tile.\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac45b82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/Edit.vue
// module id = 568
// module chunks = 1